import { render, staticRenderFns } from "./cardSpeaker.vue?vue&type=template&id=4ac1562c&scoped=true"
import script from "./cardSpeaker.vue?vue&type=script&lang=js"
export * from "./cardSpeaker.vue?vue&type=script&lang=js"
import style0 from "./cardSpeaker.vue?vue&type=style&index=0&id=4ac1562c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1562c",
  null
  
)

export default component.exports